
import {
  schema, normalize
} from 'normalizr'

// Define passes schema
const passesSchema = new schema.Entity('passes')
const passesListSchema = [passesSchema]

export function adaptPassesToStore({ data }) {
  const entries = normalize(data.results, passesListSchema)
  return {
    entries: entries.entities.passes,
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results
  }
}

export function adaptPassToApi(pass = {}) {
  return pass
}

export function adaptPassToStore({ data }) {
  return data
}